export default __webpack_public_path__ + "static/joinPage-f690d27ca1971a262aa07ae1938745ef.jpg";